import {Grid, styled} from "@mui/material";

export const AdditionalServicesContainer = styled('div')(() => {
    return {
        padding: '1rem',
        gap: '1rem'
    }
});
export const AdditionalServiceOrderPopupContainer = styled(Grid)(() => {
    return {

    }
});